import type { Order } from '@ztechapps/common.contract'
import isEmpty from 'lodash/isEmpty'
import { roundNumber } from '@ztechapps/common.utils'
import sumBy from 'lodash/sumBy'

/**
 * This will include the calculations for shipping fee, which will query from the shipping gateway
 * Every change in order items will change the weight thus will change the shipping fee amount
 */
export async function computeOrderAmount(order: Order): Promise<{ net: number; shippingFee: number; gross: number }> {
  if (isEmpty(order?.items)) return { net: 0, shippingFee: 0, gross: 0 }

  //the gross is just the sum of the items
  const gross = roundNumber(
    sumBy(order?.items, (o) => o.net ?? 0),
    2
  )

  const shippingFee = order?.shippingFee ?? 0,
    taxAmount = order?.taxAmount ?? 0,
    discount = order?.discount ?? 0

  const net = roundNumber(shippingFee + gross + taxAmount - discount, 2)
  return {
    net,
    shippingFee,
    gross,
  }
}
